import React from 'react'

const ProfilTalenta = React.lazy(() => import("./ProfilTalenta"))
const DetailProfilTalenta = React.lazy(() => import("./ProfilTalentaAdministrator/Detail"))

export const profilTalentaConfigs = [
    {
        path: '/profil-talenta',
        element: <ProfilTalenta />,
    },
    {
        path: '/profil-talenta/detail/:nip',
        element: <DetailProfilTalenta />,
        permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1']
    },
]